import * as React from 'react';
import { ScreenPickerProps } from 'app/area/codetable/item/screen-renderer/types';
import { UomSet } from 'app/area/codetable/item/screen-renderer/screen-pickers/substance/sets/uom-set';

export const UomSets = (props: ScreenPickerProps) => {
  const { codeItem: { substanceUomSet = [] } = {}, translation } = props;

  return <div className={'col-lg-12'}>
    {substanceUomSet.length > 0
      ? substanceUomSet.map((item, index) => <UomSet
        key={index}
        substanceUomSetValue={item}
        {...props} />)
      : <p className="no-content">{translation.no_options_found}</p>}
  </div>;
};
